module.exports = __webpack_public_path__ + "static/media/natours.7ae0f0ae.png";